import React, { useState, useRef } from 'react';
import Graph from './graph';
import { BAR_CHART_CONTEXT } from './constants';
import { InfoPanel } from './InfoPanel/InfoPanel';
import { roundAndFormat } from '../../utils/helpers';

// barColor - color of bars on chart
// layout - any additional layout properties or overwrite default

export default ({
  aggregate,
  data,
  title,
  xlabel,
  ylabel,
  layout,
  loading,
  onUpdate,
  onRelayout,
  onLegendClick,
  onLegendDoubleClick,
  maxY,
}) => {
  const container = useRef(null);
  const [clickedFeature, setClickedFeature] = useState({});

  const onClick = (data) => {
    let label = '';
    let valueLabel = '';
    let value = '';
    const enableInfoOnClick = !!data.points[0]?.data?.enableInfoOnClick;
    if (enableInfoOnClick) {
      for (let i = 0; i < data.points.length; i++) {
        label = data.points[i].x;
        // Work around for getting the hovertemplate value
        // since stacked charts get complicated and labels are not shown on the axis
        valueLabel = data.points[i].data.hovertemplate.split(':')[1].split('<br><b>')[1];
        value = roundAndFormat(data.points[i].y, 2);
      }
      setClickedFeature({ label, valueLabel, value });
    }
  };

  return (
    <div ref={container} style={{ width: '100%', height: '100%' }}>
      <Graph
        data={data}
        layout={{
          annotations: [
            {
              xref: 'paper',
              yref: 'paper',
              x: 1,
              xanchor: 'right',
              y: 1,
              yanchor: 'bottom',
              text: 'Source: Welligence Energy Analytics',
              showarrow: false,
              font: {
                color: 'lightgrey',
                size: 10,
              },
            },
          ],
          ...layout,
          xaxis: {
            tickangle: '45',
            ...layout.xaxis,
          },
        }}
        config={{ modeBarButtonsToRemove: ['pan2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d'] }}
        title={title}
        xlabel={xlabel}
        ylabel={ylabel}
        loading={loading}
        onClick={onClick}
        onRelayout={onRelayout}
        onUpdate={onUpdate}
        onLegendClick={onLegendClick}
        onLegendDoubleClick={onLegendDoubleClick}
        maxY={maxY}
        context={BAR_CHART_CONTEXT}
      />
      {aggregate && (
        <InfoPanel
          aggregate={aggregate}
          container={container.current}
          clickedFeature={clickedFeature}
          setClickedFeature={setClickedFeature}
        />
      )}
    </div>
  );
};
